import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Table, Button, Modal, Form, Alert } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const ExpenseTypes = () => {
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [error, setError] = useState('');

  useEffect(() => {
    fetchExpenseTypes();
  }, []);

  const fetchExpenseTypes = async () => {
    try {
      const res = await axios.get('/api/expense-types');
      setExpenseTypes(res.data);
    } catch (err) {
      setError('Failed to load expense types');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingType) {
        await axios.put(`/api/expense-types/${editingType.id}`, formData);
      } else {
        await axios.post('/api/expense-types', formData);
      }
      setShowModal(false);
      setFormData({ name: '', description: '' });
      setEditingType(null);
      fetchExpenseTypes();
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to save expense type');
    }
  };

  const handleEdit = (type) => {
    setFormData({ name: type.name, description: type.description || '' });
    setEditingType(type);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this expense type?')) return;
    try {
      await axios.delete(`/api/expense-types/${id}`);
      fetchExpenseTypes();
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to delete');
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Expense Types</h2>
        <Button variant="primary" onClick={() => { setEditingType(null); setShowModal(true); }}>
          <FaPlus className="me-2" /> Add Expense Type
        </Button>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}

      <Card>
        <Card.Body>
          <Table hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {expenseTypes.map((type, idx) => (
                <tr key={type.id}>
                  <td>{idx + 1}</td>
                  <td className="fw-bold">{type.name}</td>
                  <td>{type.description || '-'}</td>
                  <td>
                    <Button variant="outline-warning" size="sm" className="me-2" onClick={() => handleEdit(type)}>
                      <FaEdit />
                    </Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(type.id)}>
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => { setShowModal(false); setEditingType(null); }}>
        <Modal.Header closeButton>
          <Modal.Title>{editingType ? 'Edit' : 'Add'} Expense Type</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">Save</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default ExpenseTypes;
